import { Pipe, PipeTransform } from '@angular/core';
/*
 * convert bytes to Size MB, GB
 * Takes a value argument and a decimal that is default 2.
 * Usage:
 *   value | fileSize:decimals
 * Example:
 *   {{ 17710523 | fileSize:2 }}
 *   formats to: 16.68 MB
*/
@Pipe({
    name: 'fileSize',
    pure: true
})
export class FileSizePipe implements PipeTransform {

  transform(bytes: number, decimals = 2): string {
    const K_UNIT = 1024;
    const SIZES = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

    if (bytes === 0) {
      return '0 Byte';
    }

    const i = Math.floor(Math.log(bytes) / Math.log(K_UNIT));
    const result = parseFloat((bytes / Math.pow(K_UNIT, i)).toFixed(decimals)) + ' ' + SIZES[i];

    return result;
  }
}